import React from "react";
import SentPushNotificationList from "../../../components/push-notification/SentPushNotificationList";

function SentPushNotificationHistory() {
  return <SentPushNotificationList />;
}

export default SentPushNotificationHistory;
